import { Typography, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTypography = styled(Typography) `
  display: block;
  text-align: center;
  margin-top: ${themeGet('spacing.xl')};
`;
